import angular from 'angular';
import { RenderWithWrapper } from '../../global/global.react';
import { ToggleChat } from '../../modules/patient/components/toggle-chat';
class ToggleChatBridgeController {
    constructor($element, $scope) {
        this.$element = $element;
        this.$scope = $scope;
        this.render = () => {
            RenderWithWrapper(ToggleChat, {}, this.$element[0], this.$scope);
        };
    }
    $onInit() {
        this.render();
    }
}
const toggleChatBridge = {
    template: '<div></div>',
    bindings: {},
    controller: ToggleChatBridgeController,
};
export default angular
    .module('doxy.patient.toggleChat', [])
    // toggle-chat-bridge
    .component('toggleChatBridge', toggleChatBridge).name;
